module.exports = __webpack_public_path__ + "static/media/proximanova-regular.b70e64ca.ttf";